import { c as _c } from "react/compiler-runtime";
import { Modal } from "@mantine/core";
import CheckoutLoginForm from "./CheckoutLoginForm";
export default function CheckoutLoginModal(t0) {
  const $ = _c(6);
  const {
    opened,
    onClose
  } = t0;
  let t1;
  if ($[0] !== onClose) {
    t1 = <div className="flex flex-col gap-2"><CheckoutLoginForm onClose={onClose} /></div>;
    $[0] = onClose;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== onClose || $[3] !== opened || $[4] !== t1) {
    t2 = <Modal centered={true} opened={opened} onClose={onClose} title="Enter Your Details">{t1}</Modal>;
    $[2] = onClose;
    $[3] = opened;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}